import { render, staticRenderFns } from "./inoculationNum.vue?vue&type=template&id=1336d9e9&scoped=true"
import script from "./inoculationNum.vue?vue&type=script&lang=js"
export * from "./inoculationNum.vue?vue&type=script&lang=js"
import style0 from "./inoculationNum.vue?vue&type=style&index=0&id=1336d9e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1336d9e9",
  null
  
)

export default component.exports